// extracted by mini-css-extract-plugin
module.exports = {"dataGrid":"UserProfileDialog_dataGrid__sbUTm","dataLabel":"UserProfileDialog_dataLabel__1B7kE"};